import Grid from 'semantic-ui-react/dist/es/collections/Grid';
import './Grid.css';

export default Grid;
